import { render } from "./marcaslineas.vue?vue&type=template&id=40d03d05&scoped=true"
import script from "./marcaslineas.vue?vue&type=script&lang=js"
export * from "./marcaslineas.vue?vue&type=script&lang=js"

import "./marcaslineas.vue?vue&type=style&index=0&id=40d03d05&scoped=true&lang=css"

import exportComponent from "C:\\CEDIS\\cedispage2.0_general_guvi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40d03d05"]])

export default __exports__